import React, { Component } from "react";
import BeigeImg from "./091024_PMA_MissionStmt_imageBG_3.jpg";
import { Link } from "react-router-dom";
import MissionStatementPhotoUpload from "views/Help/component/MissionStatementPhotoUploadWidget";
import "./print.scss";

class MissionStatementBlock extends Component {
  render() {
    const {
      printVersion,
      fromEditor,
      agentData,
      missionStatement,
      currentArea,
      showAllEditButtons,
    } = this.props;

    let { missionStatementContent, missionStatementHeader, namePreferred } =
      missionStatement || {};
    const { mlsAreaID, mlsNeighborhood } = currentArea;
    let {
      photoURL,
      isMemberOfTeam,
      listgenUserID,
      missionStatementPhotoURL,
      listgenUserFirstName,
      teamMembers,
    } = agentData;
    let agentName = listgenUserFirstName;
    if (
      isMemberOfTeam &&
      Array.isArray(teamMembers) &&
      teamMembers.length === 2
    ) {
      agentName = `${listgenUserFirstName} & ${teamMembers[1].firstName}`;
    }
    if (
      isMemberOfTeam &&
      Array.isArray(teamMembers) &&
      teamMembers.length === 3
    ) {
      agentName = `${listgenUserFirstName}, ${teamMembers[1].firstName}, and ${teamMembers[2].firstName}`;
    }
    if (
      isMemberOfTeam &&
      Array.isArray(teamMembers) &&
      teamMembers.length === 4
    ) {
      agentName = `${listgenUserFirstName}, ${teamMembers[1].firstName}, ${teamMembers[2].firstName}, and ${teamMembers[3].firstName}`;
    }
    if (missionStatementContent && missionStatementContent.includes("\n")) {
      missionStatementContent = missionStatementContent.replace(
        "\n",
        "<br /><br />",
      );
    }

    if (mlsAreaID === "CCA-5200I") {
      missionStatementContent = `Real estate has always been a relationship business for me. I work directly with my clients, stay involved from start to finish, and believe clear communication and sound advice matter most. Having grown up in Orinda, raised my family in Lafayette, and now living at Moraga Country Club with my wife Kristi (who is also on my real estate team), I bring decades of local knowledge and experience to every transaction.  To learn more about the Kurt Piper Group go to www.kurtpipergroup.com.`;
    }
    let customSignoff;

    let sophieTsangMission = listgenUserID === "102567";
    let hasPhotoBorder = false;
    let missionStatementTextStyles;
    if (missionStatementPhotoURL && !sophieTsangMission) {
      photoURL = missionStatementPhotoURL;
    }
    if (photoURL && photoURL.includes(".jpg") && listgenUserID !== "109954") {
      hasPhotoBorder = true;
    }

    let useDefault = true;
    let pronoun = "My";
    let meOrUs = "Me";
    if (isMemberOfTeam) {
      pronoun = "Our";
      meOrUs = "Us";
    }

    let missionTitleStyles = "";
    let missionContentStyles = "";
    if (missionStatementHeader && missionStatementHeader.length >= 55) {
      missionTitleStyles = "mission-statement-title-20";
    } else if (missionStatementHeader && missionStatementHeader.length >= 50) {
      missionTitleStyles = "mission-statement-title-23";
    } else if (missionStatementHeader && missionStatementHeader.length > 45) {
      missionTitleStyles = "mission-statement-title-24";
    } else if (missionStatementHeader && missionStatementHeader.length >= 40) {
      missionTitleStyles = "mission-statement-title-26";
    }

    if (missionStatementContent && missionStatementContent.length < 280) {
      missionStatementTextStyles = "mission-statement-content-20";
    }

    let missionImageContainerStyles = "";
    if (listgenUserID === "100030") {
      missionImageContainerStyles =
        "mission-image-container-height-224-width-360";
    }
    let hideSignoff = false;
    if (listgenUserID === "102843") {
      hideSignoff = true;
    } else if (
      listgenUserID === "107130" ||
      listgenUserID === "102340" ||
      listgenUserID === "107253" ||
      listgenUserID === "109657" ||
      namePreferred
    ) {
      customSignoff = (
        <div
          className={`mission-statement-signoff ${missionStatementTextStyles}`}
        >
          <p>— {namePreferred}</p>
        </div>
      );
    } else if (listgenUserID === "102567") {
      customSignoff = (
        <div
          className={`mission-statement-signoff ${missionStatementTextStyles}`}
        >
          <p>Your Neighbor and National Real Estate Advisor, {agentName}</p>
        </div>
      );
    }

    if (
      listgenUserID === "102843" &&
      missionStatementContent &&
      missionStatementContent.length >= 1 &&
      (missionStatementContent.includes("Cuesta Park") ||
        missionStatementContent.includes("Old Mountain View") ||
        missionStatementContent.includes("Shoreline West"))
    ) {
      missionStatementContent = missionStatementContent.replace(
        "Cuesta Park",
        mlsNeighborhood,
      );
    }
    let useCustomPhoto = false;

    let missionColumnStyles = "";
    if (listgenUserID === "102843" || listgenUserID === "106141") {
      missionColumnStyles = "large-mission-statement-photo";
    }

    // Check if mission statement contains "After XX years" pattern (literal XX)
    const hasAfterYearsPattern =
      missionStatementContent &&
      /After\s+XX\s+years/i.test(missionStatementContent);
    const editButtonClassName = hasAfterYearsPattern
      ? "edit-button-mission-statement edit-button-mission-statement-flash"
      : "edit-button-mission-statement";

    let customMissionHeader;
    if (mlsAreaID === "CCA-4500M") {
      missionStatementHeader = "Get to Know Us";
      missionStatementContent =
        "Our connection to Crow Canyon Country Club spans decades. Sue purchased her first Danville home here in the 1980s—a Fairway Villa on Silver Lake Drive—and soon began helping neighbors buy and sell homes throughout the community. Later, when Sue moved to a Garden Manor on Los Robles Court, it became Mike’s first home. Those early experiences grew into a lifelong commitment to Crow Canyon and its residents. Today, our deep roots and experience help us guide homeowners with confidence. Your home is more than a transaction—it’s where life happens. Helping you achieve your goals is our passion.";
    }
    if (useCustomPhoto) {
      return (
        <div
          className={
            printVersion
              ? "print-mission-statement-block"
              : "editor-mission-statement-block"
          }
        >
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/021425_PMA_D-B-CaseStudy_3_2.jpg"
            alt="custom photo"
            className="mission-statement-custom-photo"
          />
        </div>
      );
    } else if (sophieTsangMission) {
      return (
        <div
          className={
            printVersion
              ? `print-mission-statement-block${
                  hasAfterYearsPattern ? " no-mission-statement-border" : ""
                } sophie-tsang-mission-statement-block`
              : "editor-mission-statement-block sophie-tsang-mission-statement-block"
          }
        >
          {fromEditor && (
            <MissionStatementPhotoUpload currentArea={currentArea}>
              <div className="mission-statement-photo-upload-button">
                <p>Optional: Upload Alternate</p>
                <p>Mission Statement Photo</p>
              </div>
            </MissionStatementPhotoUpload>
          )}
          {fromEditor && (
            <Link
              to={`/agent/missionstatements/${mlsAreaID}`}
              className={editButtonClassName}
            >
              <p>Click Here to Edit</p>
              <p>Mission Statement</p>
            </Link>
          )}

          <div className="mission-statement-block-bg-container">
            <img
              className="mission-statement-block-bg"
              src="https://d2onbxnrte2nim.cloudfront.net/non-covers/sophie-background-MS_849x545px.jpg"
            />
            <div className="mission-statement-content-container">
              <div className={`mission-statement-column-container`}>
                <div
                  className={`mission-statement-image-container ${missionImageContainerStyles}`}
                >
                  <img
                    src={photoURL}
                    className={`mission-statement-image ${
                      hasPhotoBorder && "mission-photo-border"
                    } sophie-mission-headshot`}
                  />
                </div>

                <div
                  className={`mission-statement-image-container ${missionImageContainerStyles}`}
                >
                  <img
                    src={missionStatementPhotoURL}
                    className={`mission-statement-image ${
                      hasPhotoBorder && "mission-photo-border"
                    } sophie-mission-map`}
                  />
                </div>
              </div>

              <div className="mission-statement-inner-container">
                <div className="mission-statement-text-container">
                  {missionStatementHeader ? (
                    <div
                      className={`mission-statement-title ${missionTitleStyles}`}
                    >
                      {missionStatementHeader}
                    </div>
                  ) : (
                    <div
                      className={`mission-statement-title ${missionTitleStyles}`}
                    >
                      Get to Know {meOrUs}
                    </div>
                  )}

                  <div
                    className={`mission-statement-text ${missionStatementTextStyles}`}
                    dangerouslySetInnerHTML={{
                      __html: missionStatementContent || "",
                    }}
                  ></div>
                  {customSignoff ? (
                    customSignoff
                  ) : (
                    <div
                      className={`mission-statement-signoff ${missionStatementTextStyles}`}
                    >
                      <p>— {agentName}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (useDefault) {
      return (
        <div
          className={
            printVersion
              ? `print-mission-statement-block${
                  hasAfterYearsPattern ? " no-mission-statement-border" : ""
                }`
              : "editor-mission-statement-block"
          }
        >
          {fromEditor && showAllEditButtons && (
            <MissionStatementPhotoUpload currentArea={currentArea}>
              <div className="mission-statement-photo-upload-button">
                <p>Optional: Upload Alternate</p>
                <p>Mission Statement Photo</p>
              </div>
            </MissionStatementPhotoUpload>
          )}
          {fromEditor && showAllEditButtons && (
            <Link
              to={`/agent/missionstatements/${mlsAreaID}`}
              className={editButtonClassName}
            >
              <p>Click Here to Edit</p>
              <p>Mission Statement</p>
            </Link>
          )}

          <div className="mission-statement-block-bg-container">
            <img
              className="mission-statement-block-bg"
              src="https://d2onbxnrte2nim.cloudfront.net/non-covers/102525_Pg3_MissionStmt_SHAPE.png"
            />
            <div className="mission-statement-content-container">
              <div
                className={`mission-statement-column-container ${missionColumnStyles}`}
              >
                <div
                  className={`mission-statement-image-container ${missionImageContainerStyles}`}
                >
                  <img
                    src={photoURL}
                    className={`mission-statement-image ${
                      hasPhotoBorder && "mission-photo-border"
                    }`}
                  />
                </div>
              </div>

              <div className="mission-statement-inner-container">
                <div className="mission-statement-text-container">
                  {customMissionHeader ? (
                    customMissionHeader
                  ) : missionStatementHeader ? (
                    <div
                      className={`mission-statement-title ${missionTitleStyles}`}
                    >
                      {missionStatementHeader}
                    </div>
                  ) : (
                    <div
                      className={`mission-statement-title ${missionTitleStyles}`}
                    >
                      Get to Know {meOrUs}
                    </div>
                  )}

                  <div
                    className={`mission-statement-text ${missionStatementTextStyles}`}
                    dangerouslySetInnerHTML={{
                      __html: missionStatementContent || "",
                    }}
                  ></div>
                  {hideSignoff ? null : customSignoff ? (
                    customSignoff
                  ) : (
                    <div
                      className={`mission-statement-signoff ${missionStatementTextStyles}`}
                    >
                      <p>— {agentName}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div
          className={
            printVersion
              ? "print-mission-statement-block-v2"
              : "editor-mission-statement-block-v2"
          }
        >
          {fromEditor && showAllEditButtons && (
            <Link to="/agent/missionstatements" className={editButtonClassName}>
              <p>Click Here to Edit</p>
              <p>Mission Statement</p>
            </Link>
          )}
          <div className="mission-statement-block-bg-container">
            <img
              className="mission-statement-block-bg"
              src="https://d2onbxnrte2nim.cloudfront.net/021325_FEB-PMA_MissionStmt_3.jpg"
            />
            <div className="mission-statement-content-container">
              <div className="mission-statement-inner-container">
                <div className="mission-statement-image-container">
                  <img
                    src={photoURL}
                    className={`mission-statement-image ${
                      hasPhotoBorder && "mission-photo-border"
                    }`}
                  />
                </div>

                <div className="mission-statement-text-container">
                  {missionStatementHeader ? (
                    <div
                      className={`mission-statement-title ${missionTitleStyles}`}
                    >
                      {missionStatementHeader}
                    </div>
                  ) : (
                    <div
                      className={`mission-statement-title ${missionTitleStyles}`}
                    >
                      Get to Know {meOrUs}
                    </div>
                  )}
                  <div
                    className={`mission-statement-text ${missionStatementTextStyles}`}
                    dangerouslySetInnerHTML={{
                      __html: missionStatementContent || "",
                    }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}

export default MissionStatementBlock;
